export const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&()*,-./:;<=>@[\\\]^_`{|}~¬'¿?¡€ºª·])[a-zA-Z\d!"#$%&()*,-./:;<=>@[\\\]^_`{|}~¬'¿?¡€ºª·]{8,}$/;
